"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStringArray = exports.isNull = exports.isBoolean = exports.isNumber = exports.isString = exports.predicateArrayOn = exports.is = exports.isStringDict = void 0;
const isStringDict = (dict) => Object.values(dict).every((i) => typeof i === 'string');
exports.isStringDict = isStringDict;
// this is a reusable type guard; run is<type>(typeString) to get back
// a typescript-safe type discrimination function. note it just uses
// typeof; if you need a more robust type guard this won't suffice
const is = (typeString) => (a) => typeof a === typeString;
exports.is = is;
// this wraps in Array.isArray with Array.every(func) where func is an existing type predicate
// meaning that for every type T we have, we can create predicates for T[] at the same time.
const predicateArrayOn = (func) => (arr) => Boolean(Array.isArray(arr) && arr.length > 0 && arr.every(func));
exports.predicateArrayOn = predicateArrayOn;
exports.isString = (0, exports.is)('string');
exports.isNumber = (0, exports.is)('number');
exports.isBoolean = (0, exports.is)('boolean');
exports.isNull = (0, exports.is)('null');
exports.isStringArray = (0, exports.predicateArrayOn)(exports.isString);
//# sourceMappingURL=Util.js.map